module.exports = __webpack_public_path__ + "img/logo-victoriacentral.a0ebc4c1.png";